import Country from '@/parsers/Country';
import {useEffect, useState} from 'react';

const CountryFlag = () => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    Country.flag().then(flag => setSrc(flag.default));
  }, []);

  if (src) {
    return <img className="country-flag" src={src} alt={src} />;
  }
  return null;
};

export default CountryFlag;
